import script from "./FaceDetection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceDetection.vue?vue&type=script&setup=true&lang=js"

import "./FaceDetection.vue?vue&type=style&index=0&id=a35288da&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a35288da"]])

export default __exports__